<template>
  <div class="box" v-loading="loading" 
    element-loading-spinner="el-icon-loading"
    element-loading-text="加载中"
    element-loading-background="rgba(0, 0, 0, 0.1)">
    <div class="content">
      <div class="box-title">
        <span>{{ datas.graphName }}</span>
      </div>
      <div id="main3" class="main3" :style="'height:'+height+'px;'"></div>
      <!-- <img class="chart-title" src="../../../img/chart_title.png" alt="">
      <img class="chart-bg" src="../../../img/chart_bg.png" alt=""> -->
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import dayjs from 'dayjs'

export default {
  props: {
    datas: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      data: [],
      dataSeries: [],
      timer: null,
      height: 0,
    };
  },
  methods: {
    dayjs,
    setChart() {
      // this.chartsSize(document.querySelector('.chart-size'),document.getElementById("main3"))
      var myChart = echarts.init(document.getElementById("main3"), 'dark');
      var option = {
        title: {
          subtext: '单位: m³/h',
          top: -8,
          left: 18
        },
        backgroundColor: '',
        color: ['#60EEFF'],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter:function(params) {
            return params[0].name +'<br>'+params[0].seriesName+': '+params[0].data+'(m³/h)'
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisTick: {
            show: true
          },
          // splitLine: {
          //   show: false
          // }
        },
        yAxis: {
          type: 'category',
          axisTick: {
            show: true
          },
          data: [],
          inverse: true,
          animationDuration: 300,
          animationDurationUpdate: 300,
        },
        series: [
          {
            name: '工作数据值',
            type: 'bar',
            data: [],
            barWidth: 12,
            label: {
              show: true,
              position: 'right',
              valueAnimation: true
            },
            itemStyle: {
              // emphasis: {
              //     barBorderRadius: 5
              // },
              // normal: {
              //     barBorderRadius: 5
              // },
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#FFB145' },
                { offset: 1, color: '#ffca80' }
              ]),
              borderRadius: [0,20,20,0],
            }
          }
        ],
        legend: {
          show: true
        },
        animationDuration: 3000,
        animationDurationUpdate: 3000,
        animationEasing: 'linear',
        animationEasingUpdate: 'linear'
      };
      option.yAxis.data = []
      option.title.subtext = '单位: '+this.data.length>0?this.data[0].unit:''
      this.data.forEach(item => {
        option.yAxis.data.push(item.equipmentName)
        option.series[0].data.push(item.value?parseFloat(item.value):0)
      });
      myChart.setOption(option);
      setTimeout(()=>{
        window.onresize = function () {
          myChart.resize();
        }
        window.addEventListener('keydown', function(event) {
          if(event.keyCode===122) {
            myChart.resize();
          }
        })
      },0)
    },
    chartsSize(container, charts) {
      function getStyle(el, name) {
        if(window.getComputedStyle) {
          return window.getComputedStyle(el, null);
        }else {
          return el.currentStyle;
        }
      }
      let hi = getStyle(container, 'height').height;
      charts.style.height = hi;
    },
    setSize() {
      let elMain = window.innerHeight
      let rBox = document.querySelector('.box')
      let rMain = document.querySelector('.main3')
      if(rBox) rBox.style.height = elMain - 212 + 'px'
      if(rMain) rMain.style.height = this.height + 'px'
    },
  },
  created() {
    this.height = this.datas.data.length * 100
  },
  mounted() {
    this.data = this.datas.data
    this.setChart()
    let that = this
    that.setSize()
    window.addEventListener('resize', function() {
      that.setSize()
    }, false);
  }
};
</script>

<style lang="less" scoped>
.main3 {
  width: 100%;
  height: 770px;
  margin: 80px auto 0;
  z-index: 2;
}
.box-title {
  color: #FFF;
  font-size: 18px;
  padding: 0 16px;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 1;
}
/deep/.el-loading-spinner .el-icon-loading{
  font-size: 40px;
}
.box {
  overflow: auto;
  background-color: #04102c;
  position: relative;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  height: 730px;
  .chart-title {
    width: 93%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 18px auto 0;
    z-index: 0;
  }
  .chart-bg {
    width: 98%;
    height: 95%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 0;
  }
  .content {
    border-radius: 10px;
    padding-bottom: 16px;
    .search {
      overflow: hidden;
    }
    .box-content {
      padding-bottom: 10px;
      >div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        height: 78px;
        color: #333;
        box-sizing: border-box;
      }
      .imgs {
        width: 48px;
        height: 48px;
        background: rgb(71, 154, 202);
        border-radius: 5px;
        text-align: center;
        line-height: 48px;
        color: #FFF;
        font-size: 24px;
        overflow: hidden;
        position: relative;
      }
      .imgs:after {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        pointer-events: none;
        background-image: radial-gradient(circle, #fff 10%, transparent 10.01%);
        background-repeat: no-repeat;
        background-position: 50%;
        transform: scale(10, 10);
        opacity: 0;
        transition: transform 0.3s, opacity 0.5s;
      }
      .imgs:active:after {
        transform: scale(0, 0);
        opacity: 0.6;
        transition: 0s;
      }
      .bg-colors1 { background-color: #FFDC60; }
      .bg-colors2 { background-color: #7ED3F4; }
      .bg-colors3 { background-color: #FF915A; }
      .bg-colors4 { background-color: #9FE080; }
      .bg-colors5 { background-color: #FF7070; }
      .bg-colors6 { background-color: #5C7BD9; }
      .title {
        font-size: 14px;
        color: #767779;
      }
      .data {
        font-size: 20px;
        margin-top: 8px;
        color: #202020;
      }
    }
  }
  .date {
    display: flex;
    align-items: center;
    .date-text {
      font-size: 12px;
      font-weight: normal;
      color: #FFF;//#767779
      margin-right: 10px;
      user-select: none;
    }
  }
}
</style>